import React from 'react';

import CustomSection from '../../custom-general/custom-section';
import ParseHTML from '../../../common/ParseHTML';

import { PCNLMaintenancePractice } from '../../../../utils/models';

import classNames from './style.module.scss';


const MaintenancePracticeReport: React.FC<PCNLMaintenancePractice> = ({ currentPractice, recommendedPractice }) => {
    return ( 
        <CustomSection sectionTitle='Maintenance Practices'>
            <div className="p-1">
                <div className="mt-2">
                    <div className={classNames.practiceHeader}>CURRENT MAINTENANCE PRACTICE</div>
                    <div className={classNames.practiceBody}><ParseHTML text={currentPractice} /></div>
                </div>

                <div className="mt-2">
                    <div className={classNames.practiceHeader}>CORRECTIVE MAINTENANCE PRACTICE</div>
                    <div className={classNames.practiceBody}><ParseHTML text={recommendedPractice} /></div>
                </div>
            </div>
        </CustomSection>
     );
};
 
export default MaintenancePracticeReport;